module.exports = __webpack_public_path__ + "static/about-5e32cb71840688f4e55ba9cf20edcb8c.jpg";